import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { CONTAINER_SIZES, FONT_SIZES } from '../../../constants/sizes.js';
import '../../Typography/src/Heading.js';
import '../../Typography/src/Link.js';
import '../../Typography/src/ListItem.js';
import '../../Typography/src/OrderedList.js';
import { Text } from '../../Typography/src/Text.js';
import '../../Typography/src/UnorderedList.js';
import modules_28f16a69 from '../styles/Avatar.module.less.js';
import SizeContext from './SizeContext.js';

const getTextSize = (size) => {
    switch (size) {
        case 60:
            return FONT_SIZES.S20;
        case 36:
        case 44:
        case 52:
        default:
            return FONT_SIZES.S16;
    }
};
/**
 * @description The Avatar component is used to represent users. And should only be used for avatars and logotypes
 *
 * @component
 * @example
 * ```jsx
 * <Avatar src="image.png" />
 * ```
 */
const Avatar = React.forwardRef((props, ref) => {
    const groupSize = React.useContext(SizeContext);
    const { size, src, className, children, ...restProps } = props;
    const cx = useStyles(modules_28f16a69);
    const classNames = cx(className, 'avatar', {
        [`size-${groupSize || size}`]: size,
    });
    const content = React.useMemo(() => {
        if (src) {
            return React.createElement("img", { className: cx('image'), src: src, alt: "avatar", loading: "lazy" });
        }
        return (React.createElement(Text, { strong: true, uppercase: true, size: getTextSize(size) }, children));
    }, [children, cx, size, src]);
    return (React.createElement("div", { ref: ref, "data-qa": "Avatar", className: classNames, ...restProps }, content));
});
Avatar.defaultProps = {
    size: CONTAINER_SIZES.S44,
};
Avatar.displayName = 'Avatar';

export { Avatar };
//# sourceMappingURL=Avatar.js.map
